import { render, staticRenderFns } from "./gtr-modal.vue?vue&type=template&id=58b6d80d&scoped=true"
import script from "./gtr-modal.ts?vue&type=script&lang=ts&external"
export * from "./gtr-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-modal.vue?vue&type=style&index=0&id=58b6d80d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6d80d",
  null
  
)

export default component.exports